import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DataTable from '../../../containers/organism/DataTable';
import CheckAuth from '../../../utils/hoc/CheckAuth';
import dateFormatIndo from '../../../utils/helpers/dateFormatIndo';
import InformationText from '../../../components/molecules/InformationText';
import Loading from '../../../components/molecules/Loading';

class Notifikasi extends Component {
	constructor(props) {
		super(props);
		this.state = {
			coloumnDataTable : [
				{ data: "subject",		width : "55%", title: "Pesan" },
				{ data: "createdAt",	width : "20%", title: "Tanggal" },
				{ data: "readStatus",	width : "15%", className : "dt-center", title: "Status" },
				{ data: "id",			width : "10%", className : "dt-center", title: "" },
			],
			coloumnDefs : [
				{
					targets: 1,
					createdCell: (td, cellData, rowData, row, col) => { 
						ReactDOM.render( <span> {dateFormatIndo(cellData, 'long', ' ', 'hm')} </span>, td );
					}
				},
				{
					targets: 2,
					createdCell: (td, cellData, rowData, row, col) => { 
						const status = (cellData) ? 'Sudah Dibaca' : 'Belum Dibaca';
						ReactDOM.render( <span> {status} </span>, td );
					}
				},
				{
					targets: 3,
					createdCell: (td, cellData, rowData, row, col) => { 
						const iconDetail = (rowData.readStatus) ? 'fas fa-envelope-open' : 'fas fa-envelope';
						ReactDOM.render( <span onClick={() => {this.props.setReadNotif(cellData, rowData.readStatus)} } className={`${iconDetail} link-dtTable`}> </span>, td );
					}
				}
			]
		};
	}

	componentDidMount = () => {
		this.props.setTitlePage({
			title : 'Nofikasi',
			breadcrumb : [
				{name : 'Beranda', url : '/dashboard', status : false},
				{name : 'Notifikasi', url : '/#', status : true},
			]
		})
	}

	render() {
		const {status} = this.props;
		const {list, isLoading} = this.props.notif;
		//console.log('HEllo', this.props.notif.list)
		return (
			<Fragment>
				{(status.loadingPage || isLoading) ? <Loading /> : (
					<DataTable 
						data = {list} 
						coloumn = {this.state.coloumnDataTable} 
						handleDetail = {this.handleDetail} 
						coloumnDefs = {this.state.coloumnDefs}
					/>
				)}
			</Fragment>
		);
	}
}




export default CheckAuth(Notifikasi);